import { render } from "./CategoryList.vue?vue&type=template&id=5156fc25"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
script.render = render

export default script